const trackButton = document.getElementById('track-button');
const complaintForm = document.querySelector('.track-complaint-form-popup');
const trackCloseBtn = document.querySelector('.track-form-close-icon');

const trackPhoneInput = document.getElementById('track-complaint-phone');
const trackComplaintInput = document.getElementById('track-complaint-id');

const trackformSubmitBtn = document.querySelector('.track-complaint-button button');
const trackPhoneError = document.querySelector('.track-phone-error-msg');
const trackIdError = document.querySelector('.track-id-error-msg');
const trackErrorMsg = document.querySelector('.track-complaint-error-msg');

const otpForm = document.getElementById('track-complaint-otp-verification');
const mainForm = document.getElementById('track-complaint-form');
const enteredNumberText = document.getElementById('track-complaint-entered-number');

const otpInputs = document.querySelectorAll('.cf-otp-input');
const otpErrorLabel = document.querySelector('.track-complaint-invalid-OTP');

const resendTextWrapper = document.querySelector('.track-complaint-resend-text');
const resendBtn = document.getElementById('track-complaint-resend-otp-button');
const otpTimerText = document.getElementById('track-complaint-otptimer');

let storedPhoneNumber = null;
let resendTimerInterval;


/* ---------------- Validation ---------------- */

function validateInput(inputElement, errorMessageElement) {
  const inputValue = inputElement.value.trim();
  const isValid = inputElement.checkValidity();
  const isFilled = inputValue !== '';

  if (!isFilled) {
    errorMessageElement.classList.add('hidden');
  } else if (!isValid) {
    errorMessageElement.classList.remove('hidden');
  } else {
    errorMessageElement.classList.add('hidden');
  }

  return isFilled && isValid;
}


/* ---------------- DIRECT FETCH BY COMPLAINT ID ---------------- */

async function fetchByComplaintId(complaintId) {
  trackformSubmitBtn.classList.add('loading');

  try {
    const response = await fetch('https://orientform.marmeto.com/api/complaint-tracking', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${sessionStorage.getItem("complaintVerificationToken")}`
       },
      body: JSON.stringify({ callId: complaintId })
    });

    const data = await response.json();

    if (data.status === 'DATA_FOUND') {
      localStorage.setItem('complaintDetails', JSON.stringify(data));
      window.location.href = '/pages/track-complaint-details';
    } else {
      alert('No complaint found with this ID');
    }
  } catch {
    alert('Failed to fetch complaint');
  } finally {
    trackformSubmitBtn.classList.remove('loading');
  }
}


/* ---------------- SEND OTP ---------------- */

async function sendOtp(phoneNumber) {
  trackformSubmitBtn.classList.add('loading');

  try {
    const response = await fetch('https://orient.marmeto.com/api/anonymous/otp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phoneNumber })
    });

    const data = await response.json();

    if (data.status === 'SUCCESS') {
      mainForm.classList.add('hidden');
      otpForm.classList.remove('hidden');

      enteredNumberText.textContent = "+91 " + phoneNumber;
      storedPhoneNumber = phoneNumber;

      startResendTimer();
    } else {
      alert('Unable to send OTP');
    }

  } catch {
    alert('OTP request failed');
  } finally {
    trackformSubmitBtn.classList.remove('loading');
  }
}


/* ---------------- VERIFY OTP ---------------- */

async function verifyOtpAndFetchComplaints(otpValue) {
  const verifyBtn = document.getElementById('track-complaint-OTP-submit-button');
  verifyBtn.classList.add('loading');

  try {
    const response = await fetch('https://orient.marmeto.com/api/anonymous/verify', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phoneNumber: storedPhoneNumber,
        otp: otpValue
      })
    });

    const data = await response.json();

    if (data.status === 'SUCCESS') {
      sessionStorage.removeItem("complaintVerificationToken");
      if (data.verificationToken) {
        sessionStorage.setItem("complaintVerificationToken", data.verificationToken);
      }
      fetchByPhoneAfterOtp();
    } else {
      otpErrorLabel.style.display = 'block';
    }

  } catch {
    otpErrorLabel.style.display = 'block';
  } finally {
    verifyBtn.classList.remove('loading');
  }
}


/* ---------------- FETCH COMPLAINTS BY PHONE ---------------- */

async function fetchByPhoneAfterOtp() {
  try {
    const response = await fetch('https://orientform.marmeto.com/api/complaint-tracking', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        "Authorization": `Bearer ${sessionStorage.getItem("complaintVerificationToken")}`
      },
      body: JSON.stringify({ customerMobileNumber: storedPhoneNumber })
    });

    const data = await response.json();

    if (data.status === 'DATA_FOUND') {
      localStorage.setItem('complaintDetails', JSON.stringify(data));
      window.location.href = '/pages/track-complaint-details';
    } else {
      alert('No complaints found for this number');
    }

  } catch {
    alert('Failed to load complaints');
  }
}


/* ---------------- RESEND OTP TIMER ---------------- */

function startResendTimer() {
  let timeLeft = 30;

  resendTextWrapper.classList.remove('hidden');
  resendBtn.classList.add('hidden');
  otpTimerText.textContent = `${timeLeft}s`;

  clearInterval(resendTimerInterval);

  resendTimerInterval = setInterval(() => {
    timeLeft--;
    otpTimerText.textContent = `${timeLeft}s`;

    if (timeLeft <= 0) {
      clearInterval(resendTimerInterval);
      resendTextWrapper.classList.add('hidden');
      resendBtn.classList.remove('hidden');
    }
  }, 1000);
}


/* ---------------- RESEND OTP CLICK ---------------- */

resendBtn.addEventListener('click', () => {
  if (!storedPhoneNumber) return;
  sendOtp(storedPhoneNumber);
});


/* ---------------- OTP INPUT AUTO MOVE ---------------- */

otpInputs.forEach((input, index) => {
  input.addEventListener('input', () => {
    if (input.value && index < otpInputs.length - 1) {
      otpInputs[index + 1].focus();
    }
  });
});


/* ---------------- MAIN FORM SUBMIT ---------------- */

mainForm.addEventListener('submit', function (e) {
  e.preventDefault();

  const phoneFilled = trackPhoneInput.value.trim() !== '';
  const idFilled = trackComplaintInput.value.trim() !== '';

  // Complaint ID direct search
  if (idFilled) {
    const validId = validateInput(trackComplaintInput, trackIdError);
    if (validId) {
      fetchByComplaintId(trackComplaintInput.value.trim());
      return;
    }
  }

  // Phone OTP flow
  if (phoneFilled) {
    const validPhone = validateInput(trackPhoneInput, trackPhoneError);
    if (validPhone) {
      sendOtp(trackPhoneInput.value.trim());
      return;
    }
  }

  trackErrorMsg.classList.remove('hidden');
});


/* ---------------- OTP FORM SUBMIT ---------------- */

otpForm.addEventListener('submit', function (e) {
  e.preventDefault();

  let otpValue = '';
  otpInputs.forEach(input => otpValue += input.value);

  if (otpValue.length !== 4) {
    otpErrorLabel.style.display = 'block';
    return;
  }

  otpErrorLabel.style.display = 'none';
  verifyOtpAndFetchComplaints(otpValue);
});


/* ---------------- POPUP OPEN / CLOSE ---------------- */

trackButton.onclick = () => {
  complaintForm.classList.remove('hidden');
  mainForm.classList.remove('hidden');
  otpForm.classList.add('hidden');
};

trackCloseBtn.onclick = () => {
  complaintForm.classList.add('hidden');
  mainForm.classList.remove('hidden');
  otpForm.classList.add('hidden');
};
